import type { ComponentProps } from 'react';
import { ChatDocumentIcon } from './ChatDocumentIcon';
import {
  CHAT_DOCUMENT_FILE_NAME_ATTRIBUTE,
  CHAT_DOCUMENT_KIND_ATTRIBUTE,
} from './chat-document-mentions';

type MarkdownSpanProps = ComponentProps<'span'> & {
  node?: unknown;
  [CHAT_DOCUMENT_KIND_ATTRIBUTE]?: string;
  [CHAT_DOCUMENT_FILE_NAME_ATTRIBUTE]?: string;
};

/** A span the document-mention pass marked leads with its document or folder icon; any other span
 * renders unchanged. */
export function MarkdownSpan({
  node: _node,
  children,
  ...rest
}: MarkdownSpanProps) {
  const kind = rest[CHAT_DOCUMENT_KIND_ATTRIBUTE];
  if (kind !== 'folder' && kind !== 'document')
    return <span {...rest}>{children}</span>;

  return (
    <span {...rest}>
      <ChatDocumentIcon
        kind={kind}
        fileName={rest[CHAT_DOCUMENT_FILE_NAME_ATTRIBUTE] || null}
      />
      {children}
    </span>
  );
}
